import {ProductsSection} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/sections.types';
import {TrackComponentParamsType} from '@aboutyou/tracking';
import {HorizontalSliderProps} from '@aboutyou/ui-components';
import React from 'react';
import {AdditionalTile} from '../../../../backend-services/ArticleDetail/Recommendations/AdditionalTile';
import {ProductTileProps} from '../../../ProductTile/ProductTile';
import {RecommendationsLane} from '../../../Recommendations/RecommendationsLane';

type OnAddToBasketCtaClickParamsType = {productId: number};

export const ProductsSlider: React.FC<
  ProductsSection &
    HorizontalSliderProps & {
      className?: string;
      streamPosition: number;
      ProductTileComponent?: React.FC<ProductTileProps>;
      onAddToBasketCtaClick?: (params: OnAddToBasketCtaClickParamsType) => void;
      trackComponentConfig: TrackComponentParamsType;
    }
> = ({
  className,
  topline,
  headline,
  products,
  more,
  streamPosition,
  promotionTracker,
  ProductTileComponent,
  onAddToBasketCtaClick,
  trackComponentConfig,
  ...sliderProps
}) => {
  return (
    <RecommendationsLane
      onAddToBasketCtaClick={onAddToBasketCtaClick}
      uniqueKey={`productsSlider-${streamPosition}`}
      className={className}
      type="list"
      streamPosition={streamPosition}
      topline={topline}
      headline={headline}
      products={products}
      ProductTileComponent={ProductTileComponent}
      promotionTracker={{
        ...promotionTracker,
        promotionName: promotionTracker.locationId ?? '',
      }}
      trackComponentConfig={trackComponentConfig}
      AdditionalTile={
        more?.type?.$case === 'discover' && (
          <AdditionalTile
            image={more.type.discover.coverImage}
            label={more.type.discover.primaryCta.label}
            href={more.type.discover.primaryCta.linkTarget.url}
          />
        )
      }
      {...sliderProps}
    />
  );
};
